import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobile, isDesktop } from 'react-device-detect';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';



import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';
import gmaplogo from '../../Assets/App_icon/gmap.png';
import whatsapp from '../../Assets/App_icon/whatsapp.png';
import notify from '../../Assets/App_icon/notify.png';


const customFilter = (option, inputValue) => {
  if (!inputValue) return true;

  return option.label
    .toLowerCase()
    .includes(inputValue.toLowerCase());
};


const OrderMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');



  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false);
  const [packmodalVisible, setPackModalVisible] = useState(false);
  const [packTransmodalVisible, setPackTransModalVisible] = useState(false);
  const [delmodalVisible, setDelModalVisible] = useState(false);
  const [delReturnmodalVisible, setDelReturnModalVisible] = useState(false);
  const [prdmodalVisible, setPrdModalVisible] = useState(false);  
  const [addPrdmodalVisible, setAddPrdModalVisible] = useState(false);   
  const [cashmodalVisible, setCashModalVisible] = useState(false);    
  const [ledgerModalVisible, setLedgerModalVisible] = useState(false); 
  const [salesDetailModalVisible, setSalesDetailModalVisible] = useState(false); 
  
  const [areas, setAreas] = useState([]);
  const [packers, setPackers] = useState([]);
  const [selectPackers, setSelectPackers] = useState('');
  const [delman, setDelman] = useState([]);
  const [selectDelman, setSelectDelman] = useState('');
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [chekedOrders, setChekedOrders] = useState([]);
  const [chekedPackOrders, setChekedPackOrders] = useState([]);
  const [chekedPackTransOrders, setChekedPacTranskOrders] = useState([]);
  const [chekedDelOrders, setChekedDelOrders] = useState([]);
  const [chekedDelReturnOrders, setChekedDelReturnOrders] = useState([]);

  const [selectedOrderDetail, setSelectedOrderDetail] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [productUnits, setProductUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('');

  const [cashAmt, setCashAmt] = useState('');
  const [remark, setRemark] = useState('');
  const [ledgerData, setLedgerData] = useState([]);
  const [selectedLedgerData, setSelectedLedgerData] = useState([]);
  const [selectedSalesDetail, setSelectedSalesDetail] = useState([]);

  const [catList, setCatLit] = useState([]);
  const [selectedCatList, setSelectedCatList] = useState('');
  const [productList, setProductList] = useState([]);
  const [selectedAddProductId, setSelectedAddProductId] = useState('');
 

  const [mobileNumber, setMobileNumber] = useState('');
  const [custDetail, setCustDetail] = useState('');

  const [sortConfig, setSortConfig] = useState({
    key: '',
    direction: 'asc'
  });

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    setSortConfig({ key, direction });
  };

  const fetchOrderList = async () => { 
    try {
      const response = await fetch(`${host_url}/order_mlist`, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
          'userid': localStorage.getItem('userid'),
        },
        body: JSON.stringify({
          type: 'list',
          store: store,
        }),
      });

      if (response.status === 401) {
        localStorage.clear();
        alert('Your account has been disabled.');
        window.location.href = "/";
        return;
      }

      const data = await response.json();

      setOrders(data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }    
  }; 

  const handleBack = () => {
    navigate('../dashboard');
  };


    useEffect(() => {
      document.title = "Order Master";
    }, []); // for Title Set

    useEffect(() => { 
      const fetchAreaList = async () => {      
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                areaId : '',
                areaName: '',
                areaEName: '',
              }),
            });
            const data = await response.json();
            setAreas(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url]); // Area List

    useEffect(() => { 
      const fetchPackerList = async () => {      
          try {
            const response = await fetch(`${host_url}/user_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                suId : '',
                suName: '',
                suMo: '',
                suRole: '',
                suStatus: '',
              }),
            });
            const data = await response.json();
            const packersData = data.filter(item => item.suRole === 'Packers');
            setPackers(packersData);
            setSelectPackers(packersData[0].suId);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchPackerList(); 
    }, [host_url]); // Packers List

    useEffect(() => { 
      const fetchDelmanList = async () => {      
          try {
            const response = await fetch(`${host_url}/delman`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                suId : '',
                suName: '',
                suMo: '',
                suRole: '',
                suStatus: '',
              }),
            });
            const data = await response.json();
            const delmanData = data.filter(item => item.delStatus === 'Y');
            setDelman(delmanData);
            setSelectDelman(delmanData[0].delId);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchDelmanList(); 
    }, [host_url]); // Dalman List

    // Escape key press handling
    useEffect(() => {
      document.title = "Order Master";
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
            if (modalVisible || addmodalVisible || cashmodalVisible ) { 
              if (prdmodalVisible || addPrdmodalVisible || cashmodalVisible || ledgerModalVisible || salesDetailModalVisible) { 
                if(salesDetailModalVisible){
                  setSalesDetailModalVisible(false);
                  setLedgerModalVisible(true);
                }else{
                  setPrdModalVisible(false); 
                  setAddPrdModalVisible(false); 
                  setCashModalVisible(false); 
                  setLedgerModalVisible(false);
                }
                
              } else { 
                if(cashmodalVisible) {
                  setCashModalVisible(false); 
                } else {
                  setModalVisible(false); 
                  setAddModalVisible(false); 
                }
              }
              
            } else if (packmodalVisible) { 
              setPackModalVisible(false); 
            } else if (packTransmodalVisible) { 
              setPackTransModalVisible(false); 
            } else if (delmodalVisible) { 
              setDelModalVisible(false);  
            } else { 
              handleBack(); 
            }
        }    
        
        
        if (event.key === "Insert") {
          if (modalVisible) {
            setAddPrdModalVisible(true);
          } else {
            setAddModalVisible(true);
          }
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, prdmodalVisible, addPrdmodalVisible, packmodalVisible, packTransmodalVisible, delmodalVisible, delReturnmodalVisible, cashmodalVisible, ledgerModalVisible, salesDetailModalVisible ]);

    useEffect(() => {  
     fetchOrderList(); 
    }, [host_url]); // Order List

    useEffect(() => {
      setChekedPackOrders(chekedOrders.filter(order => order.ordStatus === 'Booked'));
      setChekedPacTranskOrders(chekedOrders.filter(order => order.ordStatus === 'Packing'));
      setChekedDelOrders(chekedOrders.filter(order => order.ordStatus === 'Ready For Delivery'));
      setChekedDelReturnOrders(chekedOrders.filter(order => order.ordStatus === 'Out For Delivery'));
    }, [chekedOrders]); // Order Checked

    useEffect(() => {       
        const updatedOrderDetails = selectedOrderDetail.map(item => {
            if (item.ord_detail_id === selectedProduct.ord_detail_id) {
                return {
                    ...item, // Make a copy of the current item
                    prd_qty: selectedProduct.prd_qty, // Update qty
                    prd_unit: selectedProduct.prd_unit, // Update unit
                    prd_weight: selectedProduct.prd_weight, // Update weight
                    prd_amt: item.prd_unit === selectedProduct.prd_unit ? item.prd_amt : selectedProduct.prd_rate
                };
            }
            return item;
        });

        if (JSON.stringify(selectedOrderDetail) !== JSON.stringify(updatedOrderDetails)) {
            setSelectedOrderDetail(updatedOrderDetails); 
        }
    }, [selectedProduct]); // Update Selected Product

     
    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/category`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
              }),
            });
            
            const data = await response.json();
            setCatLit(data);
            setSelectedCatList(data[0].pcat_id)
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, store]);  // Category List

    useEffect(() => { 
      const fetchProductList = async () => { 
        
          try {
            const response = await fetch(`${host_url}/product`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                pcatId: selectedCatList,
              }),
            });            
            const data = await response.json();
            data.sort((a, b) => a.prd_name.trim().localeCompare(b.prd_name.trim(), 'gu'));
              const filteredData = data.filter(product => {
                return product.ranges && product.ranges.some(row => row.prange_qty > 0);
              });
              setProductList(filteredData);
               
              if (filteredData.length > 0) {
                setSelectedAddProductId(filteredData[0].prd_id);
              } else {
                setSelectedAddProductId(null); 
              }
              
            
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
       
      }; 
     fetchProductList(); 
    }, [selectedCatList]);  // Product List

    useEffect(() => { 
      if (selectedAddProductId && productList) {
        const SPDetail = productList.filter(product => product.prd_id === Number(selectedAddProductId));
        if (SPDetail.length > 0 && SPDetail[0].ranges) {
          setProductUnits(SPDetail[0].ranges);
        } else {
          setProductUnits([]); 
        }
      }
    }, [selectedAddProductId, productList]); // set Product Units
    
    useEffect(() => { 
      if (mobileNumber.length == 10 && /^[0-9]*$/.test(mobileNumber)){
        const fetchCustDetail = async () => { 
          try {
            const response = await fetch(`${host_url}/cust_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                custMo: mobileNumber,
              }),
            });            
            const data = await response.json();
            if(data.error) {
              alert(data.error);
            } else {
              setCustDetail(data[0]);              
            }
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
       fetchCustDetail();  
      } 

      if (mobileNumber.length < 10) {
        setCustDetail('');
      }
    }, [mobileNumber]); // Customer Detail

    const [custIdFilter, setCustIdFilter] = useState('');
    const [custNameFilter, setCustNameFilter] = useState('');
    const [custAreaFilter, setCustAreaFilter] = useState('');
    const [orderStatusFilter, setOrderStatusFilter] = useState('');
    const [delPackFilter, setDelPackFilter] = useState('');

    const filteredOrders = orders.filter(orders =>
      String(orders.custMo).toLowerCase().includes(custIdFilter.toLowerCase()) &&
      orders.custEName.toLowerCase().includes(custNameFilter.toLowerCase()) &&
      orders.custAreaName.toLowerCase().includes(custAreaFilter.toLowerCase()) &&
      orders.ordDelPackName.toLowerCase().includes(delPackFilter.toLowerCase()) &&
      orders.ordStatus.toLowerCase().includes(orderStatusFilter.toLowerCase())
    );


    const sortedOrders = [...filteredOrders].sort((a, b) => {
      if (!sortConfig.key) return 0;

      let valA = a[sortConfig.key] || '';
      let valB = b[sortConfig.key] || '';

      // string compare
      if (typeof valA === 'string') {
        valA = valA.toLowerCase();
        valB = valB.toLowerCase();
        return sortConfig.direction === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      // number compare
      return sortConfig.direction === 'asc'
        ? valA - valB
        : valB - valA;
    });

    const totalCount = filteredOrders.length;
    const totalWeight = filteredOrders.reduce((sum, order) => sum + Number(order.ordWeight), 0);
    const totalAmt = filteredOrders.reduce((sum, order) => sum + Number(order.ordAmt), 0);
    const detailtotalWeight = selectedOrderDetail.reduce((sum, product) => sum + Number(product.prd_weight), 0);
    const detailtotalAmt = selectedOrderDetail.reduce((sum, product) => sum + Number(product.prd_amt), 0);

    const handleOrderDetail = async (order) => {
      setModalVisible(true);
      setSelectedOrder(order);
      setRemark(order.ordRemark);
      setSelectedOrderDetail([]);
      const ordDetail = {
            ord_no: order.ordNo,
        };
      try {
        const response = await fetch(`${host_url}/order_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            orddetail: ordDetail,  
          }),
        });
        const data = await response.json();
        setSelectedOrderDetail(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleOrderDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this Order?');
        if (userConfirmed) {
          const ordDetail = {
              ord_no: selectedOrderDetail[0].ord_no,
          };
          
          try {
            const response = await fetch(`${host_url}/order_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'order_delete', 
                store: store, 
                ordersList: ordDetail,
              }),
            });
            const data = await response.json();
            setOrders(data);
            setSelectedOrderDetail([]);
            setModalVisible(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
        }
    };

    const hamdleOrderAddModal = () => {
      setAddModalVisible(true);
      setSelectedOrderDetail([]);
      setMobileNumber('');
      setCustDetail('');
    };

    const handleProductAddInNewOrder = async () => {
      if (selectedUnit && selectedAddProductId) {
        const filteredProduct = productList.filter(product => product.prd_id === Number(selectedAddProductId));
        const filteredUnits = productUnits.filter(units => units.prange_unit === selectedUnit);

        const ordAddDetail = {
            ord_no: 0,
            prd_id: filteredProduct[0].prd_id,
            pcat_id: selectedCatList,
            prd_name: filteredProduct[0].prd_name,
            prd_weight: filteredUnits[0].prange_weight,
            prd_qty: filteredUnits[0].prange_qty,
            prd_unit: filteredUnits[0].prange_unit,
            prd_amt: filteredUnits[0].prange_rate,
            pack_status: 'N'
        };

        setSelectedOrderDetail(prevDetails => [...prevDetails, ordAddDetail]);

          setProductUnits([]);
          setSelectedUnit('');
          //setSelectedAddProductId('');
          setSelectedAddProductId(null); 
                 
      } else {
        alert('Please Selct Product And Units');
        
      }
    };

    const hamdleOrderSubmit = async () => {
      console.log(selectedOrderDetail);
      setAddModalVisible(false);
      try {
        const response = await fetch(`${host_url}/order_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'order_Insert', 
            store: store, 
            packId: '0', 
            suId: '0',
            ordersList: custDetail,
            prddetail: selectedOrderDetail, 
          }),
        });
        const data = await response.json();
        setOrders(data);
        setSelectedOrderDetail([]);
        setMobileNumber('');
        setCustDetail('');
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      } 
    };

    const handleToPackers = async () => {
      setPackModalVisible(false);
      try {
        const response = await fetch(`${host_url}/order_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'pack_update', 
            store: store, 
            packId: selectPackers, 
            suId: '',
            ordersList: chekedPackOrders, 
            prddetail: '', 
          }),
        });
        const data = await response.json();
        setOrders(data);
        setChekedOrders([]);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleToPackersTrans = async () => {
      setPackTransModalVisible(false);
      try {
        const response = await fetch(`${host_url}/order_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'pack_update', 
            store: store, 
            packId: selectPackers, 
            suId: '',
            ordersList: chekedPackTransOrders, 
            prddetail: '', 
          }),
        });
        const data = await response.json();
        setOrders(data);
        setChekedOrders([]);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleToDelivery = async () => {
      setDelModalVisible(false);
      try {
        const response = await fetch(`${host_url}/order_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'del_update', 
            store: store, 
            packId: '', 
            suId: selectDelman,
            ordersList: chekedDelOrders, 
            prddetail: '', 
          }),
        });
        const data = await response.json();
        setOrders(data);
        setChekedOrders([]);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleReturnDelivery = async () => {
      setDelReturnModalVisible(false);
      try {
        const response = await fetch(`${host_url}/order_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'del_update', 
            store: store, 
            packId: '', 
            suId: selectDelman,
            ordersList: chekedDelReturnOrders, 
            prddetail: '', 
          }),
        });
        const data = await response.json();
        setOrders(data);
        setChekedOrders([]);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleCheckboxChange = (e, row, isChecked) => {
      if (isChecked) {
        setChekedOrders([...chekedOrders, row]);
      } else {
        setChekedOrders(chekedOrders.filter(order => order.ordNo !== row.ordNo));
      }
    };

    const handleSelectAllChange = (e) => {
      const isChecked = e.target.checked;
      
      if (isChecked) {
        setChekedOrders(filteredOrders);
      } else {
        // Deselect all checkboxes
        setChekedOrders([]);
      }
    };

    const handleProduct = async (product) => {
      setPrdModalVisible(true);
      setSelectedProduct(product);
      setSelectedUnit(product.prd_unit);
      try {
      const response = await fetch(`${host_url}/product_select`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lang: 'Gujarati',
          store: store,
          prdId: product.prd_id,
        }),
      });
      
      const data = await response.json();
      if (data && data.ranges) {
        setProductUnits(data.ranges);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
    };

    const handleProductAdd = async () => {
      if (selectedUnit && selectedAddProductId) {
        const filteredProduct = productList.filter(product => product.prd_id === Number(selectedAddProductId));
        const filteredUnits = productUnits.filter(units => units.prange_unit === selectedUnit);

        const ordAddDetail = {
            ord_no: selectedOrderDetail[0].ord_no,
            prd_id: filteredProduct[0].prd_id,
            prd_weight: filteredUnits[0].prange_weight,
            prd_qty: filteredUnits[0].prange_qty,
            prd_unit: filteredUnits[0].prange_unit,
            prd_amt: filteredUnits[0].prange_rate,
            pack_status: 'N'
        };

      
        try {
          const response = await fetch(`${host_url}/order_select`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'Add_Product', 
              store: store, 
              orddetail: ordAddDetail,
            }),
          });
          const data = await response.json();
          setSelectedOrderDetail(data);
          setProductUnits([]);
          setSelectedUnit('');
          setSelectedAddProductId('');
          setAddPrdModalVisible(false);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }

       fetchOrderList(); 
      } else {
        alert('Please Selct Product And Units');
      }
    };

    const handleProductUpdate = async () => {
      setPrdModalVisible(false);
      const filteredUnits = productUnits.filter(unit => selectedUnit ? unit.prange_unit === selectedUnit : true  );
      const updatedProduct = {
        ...selectedProduct,
        prd_qty: filteredUnits[0].prange_qty,
        prd_rate: filteredUnits[0].prange_rate,
        prd_weight: filteredUnits[0].prange_weight,
        prd_unit: filteredUnits[0].prange_unit
      };

      try {
        const response = await fetch(`${host_url}/order_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'ord_detail_update', 
            store: store, 
            packId: selectPackers, 
            suId: '',
            ordersList: '',
            prddetail: updatedProduct, 
          }),
        });
        const data = await response.json();
        setOrders(data);
        setSelectedProduct(updatedProduct);

      } catch (error) {
        console.error('Error fetching cities:', error);
      }
      fetchOrderList(); 
    };
    
    const handleProductDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this product?');
        if (userConfirmed) {
          const ordDetail = {
              ord_no: selectedOrderDetail[0].ord_no,
              ord_detail_id: selectedProduct.ord_detail_id,
          };
          
          try {
            const response = await fetch(`${host_url}/order_select`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'Delete_Product', 
                store: store, 
                orddetail: ordDetail,
              }),
            });
            const data = await response.json();
            setSelectedOrderDetail(data);

            setProductUnits([]);
            setSelectedUnit('');
            setSelectedAddProductId('');
            setPrdModalVisible(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          fetchOrderList(); 
        }
    };

    const hamdleCashSubmit = async () => {
      console.log("selected Order:", selectedOrder);
      console.log("selected Order Detailed:", selectedOrderDetail);

      const delivery_items = selectedOrderDetail.map(item => ({
        prd_id: item.prd_id,
        prd_unit: item.prd_unit,
        prd_qty: item.prd_qty,
        prd_amt: item.prd_amt,
      }));


      console.log("store:", store);
      console.log("del_id:", selectedOrder.ordDelId);
      console.log("ordNo:", selectedOrder.ordNo);
      console.log("ord_amt:", Math.max(5, Math.floor(selectedOrder.ordAmt / 5) * 5));
      console.log("cash_receipt:", Number(cashAmt));
      console.log("custId:", selectedOrder.custId);
      console.log("cust_name:", selectedOrder.custName);
      console.log("delivery_items:", delivery_items);

      setCashModalVisible(false);
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/admin_delivery_done`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store, 
            del_id: selectedOrder.ordDelId, 
            ord_no: selectedOrder.ordNo,
            ord_amt: Math.max(5, Math.floor(selectedOrder.ordAmt / 5) * 5), 
            cash_receipt: Number(cashAmt), 
            custId: selectedOrder.custId,
            cust_name: selectedOrder.custName,
            delivery_items : delivery_items,
          }),
        });
        const data = await response.json();
        
        setOrders(data);
      } catch (error) {
        console.error('Error Delivery Done:', error);
      }

    };

    const handleUpdateRemark = async () => {
      if(selectedOrder.ordRemark != remark) {
          const ordDetail = {
              ord_no: selectedOrder.ordNo,
              ord_remark: remark,
          };
          
          try {
            const response = await fetch(`${host_url}/order_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'remark_update', 
                store: store, 
                ordersList: ordDetail,
              }),
            });
            const data = await response.json();
            setOrders(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }

      }      
    };

    const handlePotatoAdd = async () => {
      
        const ordAddDetail = {
            ord_no: selectedOrderDetail[0].ord_no,
            prd_id: 19,
            prd_weight: "1.000",
            prd_qty: '1.000',
            prd_unit: '1 કિલો',
            prd_amt: 1,
            pack_status: 'N'
        };
        console.log("ordAddDetail", ordAddDetail );

       
      
        try {
          const response = await fetch(`${host_url}/order_select`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'Add_Product', 
              store: store, 
              orddetail: ordAddDetail,
            }),
          });
          const data = await response.json();
          setSelectedOrderDetail(data);
          setProductUnits([]);
          setSelectedUnit('');
          setSelectedAddProductId('');
          setAddPrdModalVisible(false);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }
    };

    const printLabel50x25 = () => {
      const width = 400;
      const height = 300;

      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      const printWindow = window.open(
        "",
        "",
        `width=${width},height=${height},left=${left},top=${top}`
      );

      const formatCustId = () => {
        const str = String(selectedOrder.custId);
        if (str.length <= 5) return str;
        return str.slice(0, 5) + "  " + str.slice(5);
      };

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Label</title>
            <style>
              @page {
                size: 50mm 25mm;
                margin: 0;
              }

              html, body {
                width: 50mm;
                margin: 0;
                padding: 0;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 14px;
                text-align: center;
              }

              .label {
                width: 50mm;
                height: 25mm;
                box-sizing: border-box;
                padding: 2mm;
                overflow: hidden;
              }

              .cust-name {
                font-weight: bold;
                font-size: 14px;
                line-height: 1.3;
                white-space: normal;
                word-break: break-word;
              }

              .spacer {
                height: 1mm;   /* 👈 adjust this as needed */
              }
              .spacerArea {
                height: 2mm;   /* 👈 adjust this as needed */
              }

            </style>
          </head>
          <body>
            <div class="label">
              <div class="spacerArea"></div>      
              <div class="cust-name">${selectedOrder.custAreaGName}</div>
              <div class="spacer"></div>
              <div class="cust-name">${formatCustId()}</div>
              <div class="cust-name">${selectedOrder.custName}</div>
            </div>
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 300);
    };

    const handleCustLedger = async (custId) => {
      setLedgerModalVisible(true);
      try {
        const response = await fetch(`${host_url}/cust_ledger`, {
        method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            custId: custId,
            lang: 'Gujarati',
            store: store
          }),
        });

        const data = await response.json();
        setLedgerData(data);
        console.log(data);
      } catch (error) {
        console.error('Error updating profile:', error);
      }
    };

    const handleSalesDetail = async (sale) => {

      setSalesDetailModalVisible(true);
      setLedgerModalVisible(false);
      setSelectedSalesDetail([]);
      setSelectedLedgerData(sale);
      const salesDetail = {
            sl_id: sale.tr_id,
        };
      try {
        const response = await fetch(`${host_url}/sales_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            salesdetail: salesDetail,  
          }),
        });
        const data = await response.json();
        setSelectedSalesDetail(data);
        console.log("selectedSalesDetail", data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }  
    };

    const handleParcelChange = async (value) => {
      
          const ordDetail = {
              ord_no: selectedOrder.ordNo,
              ord_parcel: value,
          };
          
          try {
            const response = await fetch(`${host_url}/order_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'parcel_update', 
                store: store, 
                ordersList: ordDetail,
              }),
            });
            const data = await response.json();
            setOrders(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
        
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Order Master</b>
                <div onClick={hamdleOrderAddModal}>
                  <img src={insertlogo} alt="Back" className='system-icon'/>
                </div>
          </div>
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr > 
                <th colSpan='2'>
                    <span style={{ display: 'flex', paddingLeft: '10px' }}>
                      {(orderStatusFilter === 'Booked' || orderStatusFilter === 'Ready For Delivery') && (
                      <span>
                        <input
                          type="checkbox"
                          value="selectAll"
                          onChange={(e) => handleSelectAllChange(e)}
                        />
                      </span>
                      )}
                      <span style={{ paddingLeft: '10px' }}>Mobile</span>
                    </span>
                </th>     
                <th colSpan='2' onClick={() => handleSort('custEName')} style={{ cursor: 'pointer' }}>
                  Name {sortConfig.key === 'custEName' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                </th>
                <th colSpan='2' onClick={() => handleSort('custAreaName')} style={{ cursor: 'pointer' }}>
                  Area {sortConfig.key === 'custAreaName' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                </th>
                <th>Item</th>
                <th>Weight</th>
                <th onClick={() => handleSort('ordAmt')} style={{ cursor: 'pointer' }}>
                  Amt {sortConfig.key === 'ordAmt' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                </th>
                <th colSpan='2' onClick={() => handleSort('ordStatus')} style={{ cursor: 'pointer' }}>
                  Status {sortConfig.key === 'ordStatus' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                </th>
                <th colSpan='2'>Pac/Del Name</th>
                <th onClick={() => handleSort('ordTime')} style={{ cursor: 'pointer' }}>Time</th>
              </tr>
              <tr>
                 <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custIdFilter}
                    onChange={(e) => setCustIdFilter(e.target.value)}
                  />
                </th>
                
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custNameFilter}
                    onChange={(e) => setCustNameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    style={{fontSize: '14px' }}
                    value={custAreaFilter}
                    onChange={(e) => setCustAreaFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    {areas.map((area) => (
                      area.order > 0 && (
                        <option key={area.areaId} value={area.areaEName}>
                          {area.areaEName}
                        </option>
                      )
                    ))}
                  </select>                  
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    style={{fontSize: '14px' }}
                    value={orderStatusFilter}
                    onChange={(e) => setOrderStatusFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Booked">Booked</option>
                    <option value="Packing">Packing</option>
                    <option value="Ready For Delivery">Ready For Delivery</option>
                    <option value="Out For Delivery">Out For Delivery</option>
                  </select>
                </th>
                 <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={delPackFilter}
                    onChange={(e) => setDelPackFilter(e.target.value)}
                  />
                </th>
                <th></th> 
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {sortedOrders.map((row) => {
                  return (
                    <tr key={row.ordNo} style={{ lineHeight: '10px' }} onClick={() => handleOrderDetail(row)}>
                      <td colSpan='2' onClick={(e) => {
                        e.stopPropagation();  
                        const checkbox = e.target.querySelector('input[type="checkbox"]');
                        if (checkbox) {
                          checkbox.checked = !checkbox.checked;
                          handleCheckboxChange(e, row, checkbox.checked);
                        }
                      }}>
                        <span style={{ display: 'flex', paddingLeft: '10px' }}>
                          {(orderStatusFilter === 'Booked' || orderStatusFilter === 'Packing' || orderStatusFilter === 'Ready For Delivery' || orderStatusFilter === 'Out For Delivery') && (
                          <span>
                            <input
                              type="checkbox"
                              value={row.ordNo}
                              checked={chekedOrders.some(order => order.ordNo === row.ordNo)}
                              onChange={(e) => handleCheckboxChange(e, row, e.target.checked)}
                            />
                          </span>
                          )}
                          <span style={{ paddingLeft: '10px' }} >
                                {isMobile ? (
                                  <a href={`tel:${row.custMo}`}>{row.custMo}</a>
                                ) : (
                                  row.custMo
                                )}
                          </span>
                        </span>
                      </td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custEName}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                      <td colSpan='2' className="cell-left">
                          <span style={{ fontWeight: 'bold', fontSize: '13px',
                                          color: row.ordStatus === 'Ready For Delivery' ? 'green' :
                                                 row.ordStatus === 'Out For Delivery' ? 'red' :
                                                 row.ordStatus === 'Packing' ? 'orange' : 'black' 
                                        }}
                          >{row.ordStatus}</span>
                      </td>
                      <td colSpan='2' className="cell-left">
                        <span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.ordDelPackName === 'Office' ? '' : row.ordDelPackName}</span>
                      </td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordTime}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th colSpan='4'>
                    {chekedOrders.length > 0 && chekedOrders.some(order => order.ordStatus === 'Booked') && orderStatusFilter === 'Booked' && (
                      <Button color="primary" style={{ marginTop: '5px', marginBottom: '5px', width: '80%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }} onClick={() => setPackModalVisible(true)} >To Packing</Button>
                    )}  
                    {chekedOrders.length > 0 && chekedOrders.some(order => order.ordStatus === 'Packing') && orderStatusFilter === 'Packing' && (
                      <Button color="warning" style={{ marginTop: '5px', marginBottom: '5px', width: '80%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }} onClick={() => setPackTransModalVisible(true)} >To Packing Transfer</Button>
                    )} 
                    {chekedOrders.length > 0 && chekedOrders.some(order => order.ordStatus === 'Ready For Delivery') && orderStatusFilter === 'Ready For Delivery' && (
                      <Button color="success" style={{ marginTop: '5px', marginBottom: '5px', width: '80%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }} onClick={() => setDelModalVisible(true)} >To Delivery</Button>
                    )} 
                    {chekedOrders.length > 0 && chekedOrders.some(order => order.ordStatus === 'Out For Delivery') && orderStatusFilter === 'Out For Delivery' && (
                      <Button color="info" style={{ marginTop: '5px', marginBottom: '5px', width: '80%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }} onClick={() => setDelReturnModalVisible(true)} >Delivery Return</Button>
                    )}              
                </th>
                <th className="cell-left" ><span style={{ paddingLeft: '10px' }}>Total</span></th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalWeight.toFixed(3)}</span></th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalAmt}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Order Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Order Detail</h5> 
                
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '48%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedOrderDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} onClick={() => handleProduct(row)}>
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td colSpan='2'className="cell-left" style={{ padding: '2px', fontSize: '14px' }} >{row.prd_unit}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                          <tr>
                            <th colSpan="2" className="cell-left" style={{ padding: "2px" }}>
                              {(() => {
                                  const totalAmount = selectedOrderDetail
                                    .filter(item => item.pcat_id === 2 || item.pcat_id === 3)
                                    .reduce((sum, item) => sum + Number(item.prd_amt || 0), 0);

                                  const hasValidItems = selectedOrderDetail.some(
                                    item => item.pcat_id === 2 || item.pcat_id === 3
                                  );

                                  const hasPotatoAlready = selectedOrderDetail.some(
                                    item => Number(item.prd_id) === 19
                                  );

                                  const isOrderEditable =
                                    selectedOrder?.ordStatus !== "Out For Delivery" &&
                                    selectedOrder?.ordStatus !== "Ready For Delivery";

                                  const canAddFreePotato =
                                    totalAmount > 249 &&
                                    hasValidItems &&
                                    !hasPotatoAlready &&
                                    isOrderEditable;

                                  return (
                                    <span
                                      onClick={() => {
                                        if (canAddFreePotato) {
                                          handlePotatoAdd();
                                        }
                                      }}
                                      style={{
                                        cursor: canAddFreePotato ? "pointer" : "default",
                                        color: canAddFreePotato ? "green" : "inherit",
                                        
                                      }}
                                    >
                                      {canAddFreePotato ? "Add Free Potato" : "Total Item : " + selectedOrderDetail.length}
                                    </span>
                                  );
                              })()}
                          </th>
                          <th className="cell-left" style={{ padding: '2px' }} >
                              <>
                                <style>
                                  {`
                                    .parcel-input::-webkit-inner-spin-button,
                                    .parcel-input::-webkit-outer-spin-button {
                                      -webkit-appearance: auto !important;
                                      opacity: 1 !important;
                                    }
                                  `}
                                </style>
                                <input
                                  type="number"
                                  min="1"
                                  max="9"
                                  step="1"
                                  className="parcel-input"
                                  value={selectedOrder.ordParcel}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    if (value === "" || /^[1-9]$/.test(value)) {
                                      setSelectedOrder({
                                        ...selectedOrder,
                                        ordParcel: value
                                      });
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const value = e.target.value;

                                    if (/^[1-9]$/.test(value)) {
                                      handleParcelChange(value);
                                    }
                                  }}
                                  style={{
                                    width: '40px',
                                    textAlign: 'center',
                                    padding: '2px',
                                  }}
                                />
                              </>
                          </th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left" style={{ width: '25%'}} >{selectedOrder.custId} </td>
                          <td className="cell-left" style={{ width: '75%', cursor: 'pointer' }}  onClick={() => printLabel50x25( selectedOrder.custAreaGName, selectedOrder.custId, selectedOrder.custAreaGName) }>{selectedOrder.custName}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Mo No :</td>
                          <td className="cell-left"> 
                                <a 
                                  href={`whatsapp://send?phone=91${selectedOrder.custMo}`} 
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  {selectedOrder.custMo}
                                </a> 
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">
                            {selectedOrder?.custLocation ? (
                              <a
                                href={`https://www.google.com/maps?q=${selectedOrder.custLocation.y},${selectedOrder.custLocation.x}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ cursor: "pointer" }}
                              >
                                <img 
                                  src={gmaplogo}   // your google map image
                                  alt="Map" 
                                  style={{ width: "20px", height: "20px" }} 
                                />
                              </a>
                            ) : (
                              "Add :"
                            )}
                          </td>
                          <td className="cell-left">{selectedOrder.custAdd}</td>
                        </tr>
                         <tr>
                          <td className="cell-left">Area :</td>
                          <td className="cell-left">{selectedOrder.custAreaName}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Balance :</td>
                          <td className="cell-left" > <span  style={{ color: Number(selectedOrder.custBalance) < 0 ? 'red' : 'inherit', cursor: "pointer" }} onClick={() => handleCustLedger(selectedOrder.custId)}>{selectedOrder.custBalance}</span></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Remark :</td>
                          <td className="cell-left" style={{ color: 'red' }}> 
                            <textarea 
                              style={{ backgroundColor: 'transparent', color: 'red',  border: '1px solid #ccc',  outline: 'none' }}
                              value={remark} 
                              onChange={(e) => setRemark(e.target.value)} 
                              onBlur={handleUpdateRemark}
                              rows="3" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                              <Button color="danger" style={{ flex: 1, marginLeft: '10px'}} onDoubleClick={handleOrderDelete} >
                                Cencle Order
                              </Button>
                                  
                              {selectedOrder.ordStatus !== 'Out For Delivery' && (
                                <Button
                                  color="success"
                                  style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }}
                                  disabled={selectedOrder.ordStatus === 'Ready For Delivery'}
                                  onClick={() => setAddPrdModalVisible(true)}
                                >
                                  Add New Item
                                </Button>
                              )}  
                              
                              {selectedOrder.ordStatus === 'Out For Delivery' && (
                                <Button
                                  color="warning"
                                  style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }}
                                  onDoubleClick={() => setCashModalVisible(true)}
                                >
                                  Delivery Done
                                </Button>
                              )}

                              <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                                Close
                              </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for Add New Order  */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Order</h5>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedOrderDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} >
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td colSpan='2'className="cell-left" style={{ padding: '2px', fontSize: '14px' }} >{row.prd_unit}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >Total</th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Id :</td>
                          <td className="cell-left">{custDetail.custId}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Name :</td>
                          <td className="cell-left">{custDetail.custEName}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Mo No :</td>
                          <td className="cell-left">
                            <input
                              type="text"
                              id="mobileNumber"
                              value={mobileNumber}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              placeholder="Registered Mobile Number"
                              maxLength="10"  
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">Add :</td>
                          <td className="cell-left">{custDetail.custEAdd}</td>
                        </tr>
                         <tr>
                          <td className="cell-left">Area :</td>
                          <td className="cell-left">{custDetail.custAreaEName}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Balance :</td>
                          <td className="cell-left">{custDetail.custBalance}</td>
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                              <Button color="info" style={{ flex: 1, marginRight: '10px' }} onClick={() => setAddPrdModalVisible(true)} >
                                Add New Item
                              </Button>
                              <Button color="success" style={{ flex: 1, marginRi: '10px', marginRight: '10px'}} onClick={hamdleOrderSubmit}  disabled={selectedOrderDetail.length < 1 || !custDetail.custId}>
                                Submit Order
                              </Button>
                              
                              <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setAddModalVisible(false)}>
                                Close
                              </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for To Packing */}
            <Modal isOpen={packmodalVisible} toggle={() => setModalVisible(!packmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                        <thead >
                          <tr >
                            <th >Cust Id</th>        
                            <th colSpan='2'>Name</th>
                            <th colSpan='2'>Area</th>
                            <th>Item</th>
                            <th>Weight</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody className="scrollable-body">
                          {chekedPackOrders.map((row) => {
                              return (
                                <tr key={row.ordNo} style={{ lineHeight: '10px' }} >
                                  <td><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                                </tr>
                              );
                          })}
                        </tbody>
                        <tfoot>
                          <tr >
                            <th className="cell-left" ><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                            <th colSpan='4'>Total</th>
                            <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '30px' }}>{totalWeight.toFixed(3)}</span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalAmt}</span></th>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '45%' }}>
                      <span style={{ marginRight: '10px' }}>Packers Man : </span>
                        <span style={{ padding: '2px' }} >
                            <select
                              value={selectPackers}
                              onChange={(e) => setSelectPackers(e.target.value)}
                            >
                              {packers.map((user) => (
                                  <option key={user.suId} value={user.suId}>
                                    {user.suName}
                                  </option>
                              ))}
                            </select>
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '45%' }}>
                      <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleToPackers}>
                        Pass To Packing
                      </Button>
                      <Button color="primary" style={{ flex: 1 }} onClick={() => setPackModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                
              </ModalBody>
            </Modal>    

          {/* Modal for To Packing Transfer */}
            <Modal isOpen={packTransmodalVisible} toggle={() => setModalVisible(!packTransmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                        <thead >
                          <tr >
                            <th >Cust Id</th>        
                            <th colSpan='2'>Name</th>
                            <th colSpan='2'>Area</th>
                            <th>Item</th>
                            <th>Weight</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody className="scrollable-body">
                          {chekedPackTransOrders.map((row) => {
                              return (
                                <tr key={row.ordNo} style={{ lineHeight: '10px' }} >
                                  <td><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                                </tr>
                              );
                          })}
                        </tbody>
                        <tfoot>
                          <tr >
                            <th className="cell-left" ><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                            <th colSpan='4'>Total</th>
                            <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '30px' }}>{totalWeight.toFixed(3)}</span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalAmt}</span></th>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '45%' }}>
                      <span style={{ marginRight: '10px' }}>Packers Man : </span>
                        <span style={{ padding: '2px' }} >
                            <select
                              value={selectPackers}
                              onChange={(e) => setSelectPackers(e.target.value)}
                            >
                              {packers.map((user) => (
                                  <option key={user.suId} value={user.suId}>
                                    {user.suName}
                                  </option>
                              ))}
                            </select>
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '45%' }}>
                      <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleToPackersTrans}>
                        Pass To Packing
                      </Button>
                      <Button color="primary" style={{ flex: 1 }} onClick={() => setPackTransModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                
              </ModalBody>
            </Modal>      

          {/* Modal for To Delivery */}
            <Modal isOpen={delmodalVisible} toggle={() => setModalVisible(!delmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                        <thead >
                          <tr >
                            <th >Cust Id</th>        
                            <th colSpan='2'>Name</th>
                            <th colSpan='2'>Area</th>
                            <th>Item</th>
                            <th>Weight</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody className="scrollable-body">
                          {chekedDelOrders.map((row) => {
                              return (
                                <tr key={row.ordNo} style={{ lineHeight: '10px' }} >
                                  <td><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                                </tr>
                              );
                          })}
                        </tbody>
                        <tfoot>
                          <tr >
                            <th className="cell-left" ><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                            <th colSpan='4'>Total</th>
                            <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '30px' }}>{totalWeight.toFixed(3)}</span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalAmt}</span></th>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '45%' }}>
                      <span style={{ marginRight: '10px' }}>Packers Man : </span>
                      <span style={{ padding: '2px' }} >
                            <select
                              value={selectDelman}
                              onChange={(e) => setSelectDelman(e.target.value)}
                            >
                              {delman.map((user) => (
                                  <option key={user.delId} value={user.delId}>
                                    {user.delName}
                                  </option>
                              ))}
                            </select>
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '45%' }}>
                      <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleToDelivery}>
                        Pass To Deliveryman
                      </Button>
                      <Button color="primary" style={{ flex: 1 }} onClick={() => setDelModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                
              </ModalBody>
            </Modal>      

          {/* Modal for Return Delivery */}
            <Modal isOpen={delReturnmodalVisible} toggle={() => setModalVisible(!delReturnmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                        <thead >
                          <tr >
                            <th >Cust Id</th>        
                            <th colSpan='2'>Name</th>
                            <th colSpan='2'>Area</th>
                            <th>Item</th>
                            <th>Weight</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody className="scrollable-body">
                          {chekedDelReturnOrders.map((row) => {
                              return (
                                <tr key={row.ordNo} style={{ lineHeight: '10px' }} >
                                  <td><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                                </tr>
                              );
                          })}
                        </tbody>
                        <tfoot>
                          <tr >
                            <th className="cell-left" ><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                            <th colSpan='4'>Total</th>
                            <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '30px' }}>{totalWeight.toFixed(3)}</span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalAmt}</span></th>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '45%' }}>
                      <span style={{ marginRight: '10px' }}>Packers Man : </span>
                      <span style={{ padding: '2px' }} >
                            <select
                              value={selectDelman}
                              onChange={(e) => setSelectDelman(e.target.value)}
                            >
                              <option key='110' value='110'>Office</option>
                              {delman.map((user) => (
                                  <option key={user.delId} value={user.delId}>
                                    {user.delName}
                                  </option>
                              ))}
                            </select>
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '45%' }}>
                      <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleReturnDelivery}>
                        {selectDelman == '110' ? 'Return To Office' : 'Pass To Deliveryman'}
                      </Button>
                      <Button color="primary" style={{ flex: 1 }} onClick={() => setDelReturnModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                
              </ModalBody>
            </Modal>      

          {/* Modal for Product Detail */}
            <Modal isOpen={prdmodalVisible} toggle={() => setModalVisible(!prdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >{selectedProduct.prd_name}</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedUnit}
                                onChange={(e) => setSelectedUnit(e.target.value)}
                              >
                                {productUnits.map((unit, index) => (
                                    <option key={index} value={unit.prange_unit}>
                                      {unit.prange_unit} == {unit.prange_rate} Rs
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductDelete} disabled={selectedOrder.ordStatus === 'Out For Delivery' || selectedOrder.ordStatus === 'Ready For Delivery'}>
                      Delete Product
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductUpdate} disabled={selectedOrder.ordStatus === 'Out For Delivery' || selectedOrder.ordStatus === 'Ready For Delivery'}>
                      Update Product
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        

          {/* Modal for Add Product Detail */}
            <Modal isOpen={addPrdmodalVisible} toggle={() => setModalVisible(!addPrdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >{selectedProduct.prd_name}</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedCatList}
                                onChange={(e) => setSelectedCatList(e.target.value)}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td style={{ padding: '2px' }} >
                              <select
                                
                                onChange={(e) => setSelectedAddProductId(e.target.value)}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td style={{ padding: '2px' }} >
                              <select
                                onChange={(e) => setSelectedUnit(e.target.value)}
                              >
                                <option key='' value=''>Select Units</option>
                                {productUnits.map((unit, index) => (
                                    <option key={index} value={unit.prange_unit}>
                                      {unit.prange_unit} == {unit.prange_rate} Rs
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={modalVisible ? handleProductAdd : handleProductAddInNewOrder}>
                      Add Item
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        

          {/* Modal for Cash Recieve */}
            <Modal isOpen={cashmodalVisible} toggle={() => setCashModalVisible(!modalVisible)} className="otpmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <>                  
                  <div >Delivery done by</div>
                  <div style={{ fontWeight: '600' }}>{selectedOrder.ordDelPackName}</div>
                  <div className="form-group">
                    <input
                      type="text"
                      value={cashAmt}
                      pattern="[0-9]*"
                      onChange={(e) => setCashAmt(e.target.value.replace(/[^0-9]/g, ''))}
                      placeholder="Cash Recieved"
                      maxLength="8"
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          hamdleCashSubmit(event.target.value);  
                        }
                      }}
                    />
                  </div>
                  
        
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={hamdleCashSubmit} disabled={!cashAmt}>
                      Recieved
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setCashModalVisible(false)}>
                      Close
                    </Button>
                  </div>    
                </>              
              </ModalBody>
            </Modal>                        

          {/* Modal for Customer Ledger */}
            <Modal isOpen={ledgerModalVisible} toggle={() => setModalVisible(!ledgerModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '2px' }} >Date</th>
                          <th style={{ padding: '2px' }} >Type</th>
                          <th style={{ padding: '2px' }} >Sales</th>
                          <th style={{ padding: '2px', paddingRight: '10px', }} >Pay</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {ledgerData.map((row, index) => {
                            return (
                              <tr key={index} >
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{new Date(row.tr_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                                <td className="cell-left" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >
                                    {row.tr_type === 'Cash_Back' ? (
                                      <span style={{color:'red'}}>{row.tr_type}</span>
                                    ) : (
                                        <span>{row.tr_type}</span>
                                    )}
                                </td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px'}}> <span style={{ cursor:'pointer'}} onClick={() => handleSalesDetail(row)} >{row.sl_amt === 0 ? '' : row.sl_amt}</span></td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.cr_amt === 0 ? '' : row.cr_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setLedgerModalVisible(false)}>
                              Close
                            </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.sl_amt || 0), 0)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.cr_amt || 0), 0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>      

          {/* Modal for Sales Detail */}
            <Modal isOpen={salesDetailModalVisible} toggle={() => setSalesDetailModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <h6>
                    {selectedOrder && `${selectedOrder.custName} - `}
                    {new Date(selectedLedgerData.tr_date)
                      .toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      .replace(/\//g, "-")}
                  </h6>
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedSalesDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_qty}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody> 
                      <tfoot>
                        {(selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0)) < 0) && (
                          <tr>
                            <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Round off</td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} ></td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0))}</td>
                          </tr>
                        )}
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >
                              <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => {setSalesDetailModalVisible(false); setLedgerModalVisible(true);}}>
                                Close
                              </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >
                              {
                                (
                                  selectedSalesDetail.reduce(
                                    (sum, item) => sum + Number(item.sd_prd_qty),
                                    0
                                  ) 
                                ).toFixed(3)
                              }
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >
                              {
                                (
                                  selectedSalesDetail.reduce(
                                    (sum, item) => sum + Number(item.sd_prd_amt),
                                    0
                                  ) +
                                  (
                                    selectedLedgerData.sl_amt -
                                    selectedSalesDetail.reduce(
                                      (sum, item) => sum + Number(item.sd_prd_amt),
                                      0
                                    )
                                  )
                                )
                              }
                          </th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>    
    </div>
  );
};

export default OrderMaster;
